import RefFaskes from "@/services/bridgingVclaim/RefFaskes";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeRefFaskes" })
class RefFaskesStore extends VuexModule {
  refFaskes = [];



  @Mutation SET_REF_FASKES(refFaskes) {
    this.refFaskes = refFaskes;
  }

  @Action act_ref_faskes(nama) {
    const dt = RefFaskes.getRefFaskes(nama)
    dt.then(dt => {
      const refFaskes = dt.data
      this.SET_REF_FASKES(refFaskes);
    });
  }


}

export const storeRefFaskes = getModule(RefFaskesStore);
